import { render, staticRenderFns } from "./ResourceState.vue?vue&type=template&id=4cf54572&scoped=true"
import script from "./ResourceState.vue?vue&type=script&lang=js"
export * from "./ResourceState.vue?vue&type=script&lang=js"
import style0 from "./ResourceState.vue?vue&type=style&index=0&id=4cf54572&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf54572",
  null
  
)

export default component.exports